/* =========================================================================
 * Kkumi · Swipe to dismiss — window.KKSwipe
 * -------------------------------------------------------------------------
 * The one touch gesture for closing a drawer / sheet by swiping it back the
 * way it came (mobile menu → left, cart drawer → right, points sheet →
 * down on phones / right from 640px). The panel follows the finger, then
 * either closes (dragged past a third of its size, or flicked) or springs
 * back. Taps on the backdrop are NOT handled here — each drawer owns its own
 * backdrop click (and remember base.css hides EMPTY <div>s, so a backdrop
 * needs `display: block` or it can't be tapped; see FRONTEND.md).
 *
 *   KKSwipe.attach(root, {
 *     edge:     'left' | 'right' | 'bottom' | function () { return edge },  // the side the panel leaves toward
 *     onClose:  function () {},            // required — close it exactly as the X button does
 *     panel:    '.sel',                    // optional: the moving element, found under `root`
 *                                          //   (use when the panel is re-rendered; default = root)
 *     enabled:  function () { return bool },   // optional: false while the drawer is shut
 *     canClose: function () { return bool },   // optional: false while busy (the panel springs back)
 *     ignore:   '.sel'                     // optional: extra selector that never starts a drag
 *   });
 *
 * Listeners sit on `root`, so a re-rendered panel keeps working. Inputs,
 * textareas, selects and anything inside [data-kk-noswipe] never start a
 * drag; neither does a touch on something that can still scroll that way
 * (a scrolled list for a bottom sheet, any horizontal scroller otherwise).
 * ========================================================================= */
(function () {
  'use strict';
  if (window.KKSwipe) return;

  var AXIS = { left: 'x', right: 'x', bottom: 'y' };
  var SIGN = { left: -1, right: 1, bottom: 1 };
  var NEVER = 'input, textarea, select, [data-kk-noswipe]';

  function scrolls(el, axis) {
    var cs = window.getComputedStyle(el);
    var o = axis === 'x' ? cs.overflowX : cs.overflowY;
    if (!/(auto|scroll)/.test(o)) return false;
    return axis === 'x' ? el.scrollWidth > el.clientWidth : el.scrollHeight > el.clientHeight;
  }

  // Something between the touch and the panel could still scroll in this direction.
  function blocked(target, panel, edge) {
    var axis = AXIS[edge];
    for (var el = target; el && el.nodeType === 1; el = el.parentNode) {
      if (scrolls(el, axis) && (axis === 'x' || el.scrollTop > 2)) return true;
      if (el === panel) break;
    }
    return false;
  }

  function attach(root, o) {
    if (!root || !o || typeof o.onClose !== 'function') return;
    var s = null;

    function edgeNow() { return typeof o.edge === 'function' ? o.edge() : o.edge; }

    root.addEventListener('touchstart', function (e) {
      s = null;
      var t = e.target;
      if (e.touches.length !== 1 || !t || !t.closest) return;
      if (o.enabled && !o.enabled()) return;
      var panel = o.panel ? t.closest(o.panel) : root;
      if (!panel || !root.contains(panel)) return;
      if (t.closest(NEVER) || (o.ignore && t.closest(o.ignore))) return;
      var edge = edgeNow();
      if (!AXIS[edge] || blocked(t, panel, edge)) return;
      var r = panel.getBoundingClientRect();
      var p = e.touches[0];
      s = {
        panel: panel, edge: edge, x: p.clientX, y: p.clientY, drag: false,
        size: AXIS[edge] === 'x' ? r.width : r.height, d: 0, v: 0, at: Date.now()
      };
    }, { passive: true });

    root.addEventListener('touchmove', function (e) {
      if (!s) return;
      var p = e.touches[0];
      var dx = p.clientX - s.x;
      var dy = p.clientY - s.y;
      var horiz = AXIS[s.edge] === 'x';
      var along = horiz ? dx : dy;
      var across = horiz ? dy : dx;
      if (!s.drag) {
        if (Math.abs(along) < 8 && Math.abs(across) < 8) return;
        // Wrong axis, or toward the inside of the screen: not ours — let it scroll.
        if (Math.abs(across) > Math.abs(along) || along * SIGN[s.edge] <= 0) { s = null; return; }
        s.drag = true;
        s.panel.style.transition = 'none';
      }
      var d = Math.max(0, along * SIGN[s.edge]);
      var now = Date.now();
      s.v = (d - s.d) / (now - s.at || 1);
      s.d = d;
      s.at = now;
      s.panel.style.transform = horiz ? 'translateX(' + (SIGN[s.edge] * d) + 'px)' : 'translateY(' + d + 'px)';
      if (e.cancelable) e.preventDefault();
    }, { passive: false });

    function end(cancelled) {
      if (!s) return;
      var g = s;
      s = null;
      if (!g.drag) return;
      var el = g.panel;
      var shut = !cancelled && (g.d > g.size * 0.35 || g.v > 0.5) && (!o.canClose || o.canClose());
      if (shut) {
        // Hand back to the stylesheet in the same frame as the close, so its own
        // slide-out runs from where the finger left the panel.
        el.style.transition = '';
        el.style.transform = '';
        o.onClose();
      } else {
        el.style.transition = 'transform .2s ease';
        el.style.transform = '';
        setTimeout(function () { el.style.transition = ''; }, 220);
      }
    }
    root.addEventListener('touchend', function () { end(false); }, { passive: true });
    root.addEventListener('touchcancel', function () { end(true); }, { passive: true });
  }

  window.KKSwipe = { attach: attach };
})();
